import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'

const APP_VERSION = process.env.REACT_APP_VERSION

const Content: FC<WithChildren> = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <>
      <div id='kt_content_container' className='p-4 h-100'>
        {children}
      </div>
      <section className='mt-20 text-center'>
        <div className='d-flex justify-content-center align-items-center gap-12'>
          <div className='d-flex flex-column gap-2'>
            <div className='d-flex align-items-center gap-20'>
              <a className='fw-bold' href='#'>
                Contact Us
              </a>
              <a className='fw-bold' href='#'>
                About everyvisit
              </a>

              <a className='fw-bold' href='#'>
                mastercard.com
              </a>
              <a className='fw-bold' href='#'>
                Terms of Use
              </a>

              <a className='fw-bold' href='#'>
                Privacy Notice
              </a>

              <a className='fw-bold' href='#'>
                Accessibility Statement
              </a>
            </div>

            <div className='pb-8'>
              <p className='text-black fs-8'>
                Mastercard and everyvisit are registered trademarks, and the circles design is a
                trademark of Mastercard International Incorporated. ©2026 Mastercard
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export {Content}
